import React from 'react'

import { withRouter } from 'react-router-dom'

import { AuthContext } from '../../main/ProvedorAutenticacao'
import { Toast } from 'primereact/toast';
import { InputMask } from 'primereact/inputmask';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog'
import { DataTable } from 'primereact/datatable' 
import { Column } from 'primereact/column'
import { InputText } from 'primereact/inputtext';
import { Tag } from 'primereact/tag';
import { Chart } from 'primereact/chart';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import GraficoProcessoService from '../../app/service/GraficoProcessoService'
import FinanceiroService from '../../app/service/FinanceiroService'
import ConfiuracaoProcessoParadoService from '../../app/service/ConfiguracaoProcessoParadoService'

import NavBar from '../../componentes/Navbar'
import './processo.css'
import './processo2.css'
import './calendario.css'

class PainelGerencialProcesso extends React.Component {
  constructor(props) {
    super(props);

    this.graficoProcessoService = new GraficoProcessoService();
    this.financeiroService = new FinanceiroService();
    this.confiuracaoProcessoParadoService = new ConfiuracaoProcessoParadoService();

    this.cardProcessosParados = this.cardProcessosParados.bind(this);
    this.renderFooterConfiguracaoProcessosParados = this.renderFooterConfiguracaoProcessosParados.bind(this);
    this.renderFooterProcessosParados = this.renderFooterProcessosParados.bind(this);
    this.abrirProcessoLink = this.abrirProcessoLink.bind(this);
    this.acoesProcessosParados = this.acoesProcessosParados.bind(this);

    this.state = {
      meses: [],
      totalProcessos: '',
      totalAtivos: '',
      totalAtivoPercentual: '',
      totalExcluidos: '',
      totalExcluidosPercentual: '',
      totalArquivados: '',
      totalArquivadosPercentual: '',
      totalParados: '',
      totalParadosPercentual: '',
      totalProcessosPush: '',
      totalProcessosPushPercentual: '',
      statusProcessual: [],
      pieStatusProcessual: [],
      grupoTrabalho: [],
      pieGrupoTrabalho: [],
      areaAtuacao: [],
      pieAreaAtuacao: [],
      tipoAcao: [],
      pieTipoAcao: [],
      objetosAcao: [],
      pieObjetosAcao: [],
      openSpinner: false,
      detail: '',
      arquivados: [],
      cadastrados: [],
      graficoArquivadosCadastrados: null,
      //Processos Parados
      processosParados: [],
      totalProcessosParados: '',
      totalPercentualProcessosParados: '',
      diasProcessosParados: '',
      configuracaoProcessosObj: null,
      modalProcessosParados: false,
      paramProcessoPrincipal: '',
      //Filtro de Processos Parados
      processoParadoFiltraCnj: '',
      processoParadoFiltraProcesso: '',
      processoParadoFiltraParte: '',
      modalFiltroProcessoParado: false,
      exibirMensagemFiltro: 'none',
      mensagemFiltro: '',
      //Processos Cadastrados este Mês
      processosCadastradosEsteMes: [],
      totalProcessosCadastradosEsteMes: '',
      percentualProcessosCadastradosEsteMes: '',
      modalProcessosEsteMes: false,
      //Modal de configuração de processos parados
      modalConfiguracaoProcessosParados: false,
      diasConf: '',
      processosArquivados: [],
      modalProcessosArquivados: false,
      //Processo na Lixeira
      modalProcessosLixeira: false,
      processosLixeira: [],
    }

    this.options = this.getLightTheme();
  }

  exibirProcessosLixeira = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.setState({openSpinner: true});
    await this.graficoProcessoService.consultarProcesosLixeira(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({processosLixeira: response.data});
        this.abrirModal('modalProcessosLixeira');
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos Lixeira', detail:`${this.state.detail}`, life: 4000});
      })
  }

  exibirProcessosArquivados = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.setState({openSpinner: true});
    await this.graficoProcessoService.consultarProcessosArquivados(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({processosArquivados: response.data});
        this.abrirModal('modalProcessosArquivados');
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos Arquivados', detail:`${this.state.detail}`, life: 4000});
      })
  }

  filtrarProcessosParados = () => {
    this.setState({processoParadoFiltraCnj: ''});
    this.setState({processoParadoFiltraProcesso: ''});
    this.setState({processoParadoFiltraParte: ''});
    this.abrirModal('modalFiltroProcessoParado');
  }

  aplicarFiltroProcessoParado = async () => {
    this.setState({openSpinner: true});
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.consultarProcessosParadosFiltro(usuarioLogado.empresa.codigo);
    this.setState({openSpinner: false});
    this.fecharModal('modalFiltroProcessoParado');
  }

  abrirProcessoLink(rowData) {
    return(
      <div className="product-name" style={{textAlign: 'left'}}><a className="cursor" 
                                    href={this.state.paramProcessoPrincipal}
                                    target="_blank"
                                    onClick={() => this.abrirProcesso(rowData)}>{rowData.nrCnj}</a></div>
    );
  }

  acoesProcessosParados(rowData) {
    return(
      <div className="product-name" 
           style={{textAlign: 'left'}}><a className="cursor" 
           href={this.state.paramProcessoPrincipal}
           target="_blank"
           onClick={() => this.abrirProcesso(rowData)}>{rowData.nrCnj}</a></div>
    );
  }

  abrirProcesso(processo) {
    this.setState({paramProcessoPrincipal: `#/fichaProcesso/${processo.codigo}/SEARCH`});
  }

  renderFooterConfiguracaoProcessosParados(name) {
    return (
        <div className="right">
            <Button label="Alterar" 
                    onClick={this.alterarConfiguracaoProcessosParados}
                    className="p-button-primary p-button-text"/>
            &nbsp;
            <Button label="Fechar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  renderFooterProcessosParados(name) {
    return (
        <div className="right">
            <Button label="Fechar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModal(name)}/>
        </div>
    );
  }

  consularProcessosCadatradosEsteMes = async (empresa) => {
    await this.graficoProcessoService.consultarProcessosCadastradosEsteMes(empresa)
      .then(response => {
        this.setState({processosCadastradosEsteMes: response.data});
        this.setState({totalProcessosCadastradosEsteMes: response.data.length});
        const percent = parseInt(response.data.length)/parseInt(this.state.totalProcessos) * 100;
        this.setState({percentualProcessosCadastradosEsteMes: percent.toFixed(0)});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos cadastrados este mês', detail:`${this.state.detail}`, life: 4000});
      })
  }

  exibirProcessosCadastradosEsteMes = () => {
    this.abrirModal('modalProcessosEsteMes');
  }

  consultarProcessosParados = async (empresa) => {
    
    const filtro = {
      numeroCnj: this.state.processoParadoFiltraCnj,
      numeroProcesso: this.state.processoParadoFiltraProcesso,
      parte: this.state.processoParadoFiltraParte
    }

    await this.graficoProcessoService.consultarProcessosParados(empresa,filtro)
      .then(response => {
        this.setState({processosParados: response.data});
        this.setState({totalProcessosParados: response.data.length});
        const percent = parseInt(response.data.length)/parseInt(this.state.totalProcessos) * 100;
        this.setState({totalPercentualProcessosParados: percent.toFixed(0)});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos Paradados', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarProcessosParadosFiltro = async (empresa) => {
    
    const filtro = {
      numeroCnj: this.state.processoParadoFiltraCnj,
      numeroProcesso: this.state.processoParadoFiltraProcesso,
      parte: this.state.processoParadoFiltraParte
    }

    await this.graficoProcessoService.consultarProcessosParados(empresa,filtro)
      .then(response => {
        this.setState({processosParados: response.data});
        this.setState({mensagemFiltro: 'O resultado do filtro encontrou ' + response.data.length + " processo(s)"});
        this.setState({exibirMensagemFiltro: 'hide'});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos Paradados', detail:`${this.state.detail}`, life: 4000});
      })
  }

  exibirProcessosParados = () => {
    this.abrirModal('modalProcessosParados');
  }

  consultarConfiguracaoProcessoParado = async (empresa) => {
    await this.confiuracaoProcessoParadoService.consultar(empresa)
      .then(response => {
        this.setState({diasProcessosParados: response.data.dias});
        this.setState({configuracaoProcessosObj: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos Paradados Configuração', detail:`${this.state.detail}`, life: 4000});
      })
  }

  editarConfiguracaoProcessoParado = async () => {
    this.abrirModal('modalConfiguracaoProcessosParados');
  }

  alterarConfiguracaoProcessosParados = async () => {
    if(this.state.diasProcessosParados == '') {
      this.toast.show({severity:'error', summary: 'Processos Paradados Configuração', detail:'Informe os dias de configuração', life: 4000});
      return;
    }
    const usuarioLogado = this.context.usuarioAutenticado;
    const conf = {
      codigo: this.state.configuracaoProcessosObj.codigo,
      empresa: usuarioLogado.empresa,
      dias: this.state.diasProcessosParados
    }

    this.setState({openSpinner: true});
    await this.confiuracaoProcessoParadoService.alterar(conf)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Processos Paradados Configuração', detail:'Configuração alterada com sucesso!', life: 4000});
        this.fecharModal('modalConfiguracaoProcessosParados');
        this.setState({openSpinner: false});
      }).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos Paradados Configuração', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: true});
      await this.consultarConfiguracaoProcessoParado(usuarioLogado.empresa.codigo);
      await this.consultarProcessosParados(usuarioLogado.empresa.codigo);
      this.setState({openSpinner: false});
  }

  totalProcessos = (usuario) => {
    this.graficoProcessoService.totalProcessos(usuario.empresa.codigo)
      .then(response => {
        this.setState({totalProcessos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Total', detail:`${this.state.detail}`, life: 4000});
      })
  }

  processosAtivos = async (usuario) => {
    await this.graficoProcessoService.totalAtivos(usuario.empresa.codigo)
      .then(response => {
        this.setState({totalAtivos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Ativos', detail:`${this.state.detail}`, life: 4000});
      });

      const percent = parseInt(this.state.totalAtivos)/parseInt(this.state.totalProcessos) * 100;
      this.setState({totalAtivoPercentual: percent.toFixed(0)});
  }

  processosParados = async (usuario) => {
    await this.graficoProcessoService.totalParados(usuario.empresa.codigo)
      .then(response => {
        this.setState({totalParados: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Parados', detail:`${this.state.detail}`, life: 4000});
      });

      const percent = (parseInt(this.state.totalParados) / parseInt(this.state.totalProcessos)) * 100;
      this.setState({totalParadosPercentual: percent.toFixed(0)});
  }

  processosArquivados = async (usuario) => {
    await this.graficoProcessoService.totalArquivados(usuario.empresa.codigo)
      .then(response => {
        this.setState({totalArquivados: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Arquivados', detail:`${this.state.detail}`, life: 4000});
      });

      const percent = (parseInt(this.state.totalArquivados) / parseInt(this.state.totalProcessos)) * 100;
      this.setState({totalArquivadosPercentual: percent.toFixed(0)});
  }

  processosExcluidos = async (usuario) => {
    await this.graficoProcessoService.totalExcluidos(usuario.empresa.codigo)
      .then(response => {
        this.setState({totalExcluidos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Excluidos', detail:`${this.state.detail}`, life: 4000});
      });

      const percent = (parseInt(this.state.totalExcluidos) / parseInt(this.state.totalProcessos)) * 100;
      this.setState({totalExcluidosPercentual: percent.toFixed(0)});
  }

  processosPush = async (usuario) => {
    await this.graficoProcessoService.totalProcessosPush(usuario.empresa.codigo)
      .then(response => {
        this.setState({totalProcessosPush: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Push', detail:`${this.state.detail}`, life: 4000});
      });

      const percent = (parseInt(this.state.totalProcessosPush) / parseInt(this.state.totalProcessos)) * 100;
      this.setState({totalProcessosPushPercentual: percent.toFixed(0)});
  }

  statusProcessual = async (usuario) => {
    await this.graficoProcessoService.graficoStatusProcessual(usuario.empresa.codigo)
      .then(response => {
        this.setState({statusProcessual: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Gráficos', detail:`${this.state.detail}`, life: 4000});
      });

      //Nome
      let nomes = [];
      for(let i = 0; i < this.state.statusProcessual.length; i++) {
        nomes.push(this.state.statusProcessual[i].nome);
      }
      //Cores
      let cores = [];
      for(let i = 0; i < this.state.statusProcessual.length; i++) {
        cores.push(this.state.statusProcessual[i].cor);
      }

      //Quantidade
      let valores = [];
      for(let i = 0; i < this.state.statusProcessual.length; i++) {
        valores.push(this.state.statusProcessual[i].quantidade);
      }

      this.setState({pieStatusProcessual: {
        labels: nomes,
        datasets: [
          {
            data: valores,
            backgroundColor: cores,
          }
        ]
      }});
  }

  grupoTrabalho = async (usuario) => {
    await this.graficoProcessoService.graficoGrupoTrabalho(usuario.empresa.codigo)
      .then(response => {
        this.setState({grupoTrabalho: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Gráficos', detail:`${this.state.detail}`, life: 4000});
      });

      //Nome
      let nomes = [];
      for(let i = 0; i < this.state.grupoTrabalho.length; i++) {
        nomes.push(this.state.grupoTrabalho[i].nome);
      }
      //Cores
      let cores = [];
      for(let i = 0; i < this.state.grupoTrabalho.length; i++) {
        cores.push(this.state.grupoTrabalho[i].cor);
      }

      //Quantidade
      let valores = [];
      for(let i = 0; i < this.state.grupoTrabalho.length; i++) {
        valores.push(this.state.grupoTrabalho[i].quantidade);
      }

      this.setState({pieGrupoTrabalho: {
        labels: nomes,
        datasets: [
          {
            label: '',
            data: valores,
            backgroundColor: cores,
          }
        ]
      }});
  }

  areaAtuacao = async (usuario) => {
    await this.graficoProcessoService.graficoAreaAtuacao(usuario.empresa.codigo)
      .then(response => {
        this.setState({areaAtuacao: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Gráficos', detail:`${this.state.detail}`, life: 4000});
      });

      //Nome
      let nomes = [];
      for(let i = 0; i < this.state.areaAtuacao.length; i++) {
        nomes.push(this.state.areaAtuacao[i].nome);
      }
      //Cores
      let cores = [];
      for(let i = 0; i < this.state.areaAtuacao.length; i++) {
        cores.push(this.state.areaAtuacao[i].cor);
      }

      //Quantidade
      let valores = [];
      for(let i = 0; i < this.state.areaAtuacao.length; i++) {
        valores.push(this.state.areaAtuacao[i].quantidade);
      }

      this.setState({pieAreaAtuacao: {
        labels: nomes,
        datasets: [
          {
            data: valores,
            backgroundColor: cores,
          }
        ]
      }});
  }

  tipoAcao = async (usuario) => {
    await this.graficoProcessoService.graficoTipoAcao(usuario.empresa.codigo)
      .then(response => {
        this.setState({tipoAcao: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Gráficos', detail:`${this.state.detail}`, life: 4000});
      });

      //Nome
      let nomes = [];
      for(let i = 0; i < this.state.tipoAcao.length; i++) {
        nomes.push(this.state.tipoAcao[i].nome);
      }
      //Cores
      let cores = [];
      for(let i = 0; i < this.state.tipoAcao.length; i++) {
        cores.push(this.state.tipoAcao[i].cor);
      }

      //Quantidade
      let valores = [];
      for(let i = 0; i < this.state.tipoAcao.length; i++) {
        valores.push(this.state.tipoAcao[i].quantidade);
      }

      this.setState({pieTipoAcao: {
        labels: nomes,
        datasets: [
          {
            data: valores,
            backgroundColor: cores,
          }
        ]
      }});
  }

  objetosAcao = async (usuario) => {
    await this.graficoProcessoService.graficoObjetosAcao(usuario.empresa.codigo)
      .then(response => {
        this.setState({objetosAcao: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Gráficos', detail:`${this.state.detail}`, life: 4000});
      });

      //Nome
      let nomes = [];
      for(let i = 0; i < this.state.objetosAcao.length; i++) {
        nomes.push(this.state.objetosAcao[i].nome);
      }
      //Cores
      let cores = [];
      for(let i = 0; i < this.state.objetosAcao.length; i++) {
        cores.push(this.state.objetosAcao[i].cor);
      }

      //Quantidade
      let valores = [];
      for(let i = 0; i < this.state.objetosAcao.length; i++) {
        valores.push(this.state.objetosAcao[i].quantidade);
      }

      this.setState({pieObjetosAcao: {
        labels: nomes,
        datasets: [
          {
            data: valores,
            backgroundColor: cores,
          }
        ]
      }});
  }
  
  consultarPainel = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.setState({openSpinner: true});
    await this.listarMeses();
    await this.totalProcessos(usuarioLogado);
    await this.consultarConfiguracaoProcessoParado(usuarioLogado.empresa.codigo);
    await this.consultarProcessosParados(usuarioLogado.empresa.codigo);
    await this.consularProcessosCadatradosEsteMes(usuarioLogado.empresa.codigo);
    await this.processosAtivos(usuarioLogado);
    await this.processosExcluidos(usuarioLogado);
    await this.processosParados(usuarioLogado);
    await this.processosArquivados(usuarioLogado);
    await this.processosPush(usuarioLogado);
    await this.statusProcessual(usuarioLogado);
    await this.grupoTrabalho(usuarioLogado);
    await this.areaAtuacao(usuarioLogado);
    await this.tipoAcao(usuarioLogado);
    await this.objetosAcao(usuarioLogado);
    await this.consultarArquivadosCadastrados(usuarioLogado)
    this.setState({openSpinner: false});
  }

  async componentDidMount() {
    this.setState({openSpinner: true});
    await this.consultarPainel();
    this.setState({openSpinner: false});
  }

  consultarGraficoArquivados = async (usuario) => {
    const dataAtual = new Date();
    const anoAtual = dataAtual.getFullYear();
    var dataFormatadaInicial =  anoAtual+"-01-01";
    var dataFormatadaFinal =  anoAtual+"-12-31";
    await this.graficoProcessoService.graficoProcessoArquivado(usuario.empresa.codigo, dataFormatadaInicial, dataFormatadaFinal)
      .then(response => {
        this.setState({arquivados: response.data});
      }).catch(error => {
        console.log('Cadastrados', error);
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Gráficos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarGraficoCadastrados = async (usuario) => {
    const dataAtual = new Date();
    const anoAtual = dataAtual.getFullYear();
    var dataFormatadaInicial =  anoAtual+"-01-01";
    var dataFormatadaFinal =  anoAtual+"-12-31";
    await this.graficoProcessoService.graficoProcessoMes(usuario.empresa.codigo, dataFormatadaInicial, dataFormatadaFinal)
      .then(response => {
        this.setState({cadastrados: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processos - Gráficos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarMeses = async () => {
    await this.financeiroService.listarMeses()
      .then(response => {
        this.setState({meses: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Financeiro - Meses', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarArquivadosCadastrados = async (usuario) => {
    await this.consultarGraficoCadastrados(usuario);
    await this.consultarGraficoArquivados(usuario);
    
    let nomesMeses = [];

    for(let k = 0; k < this.state.meses.length; k++) {
      nomesMeses.push(this.state.meses[k].mes);
    }
    
    let arquivados = [];
    for(let i = 0; i < this.state.arquivados.length; i++) {
      console.log('Está entrando aqui')
      arquivados.push(this.state.arquivados[i].total);
    }

    let cadastrados = [];
    for(let j = 0; j < this.state.cadastrados.length; j++) {
      cadastrados.push(this.state.cadastrados[j].total);
    }

    await this.setState({basicData2: {
      labels: nomesMeses,
      datasets: [
        {

          label: 'Cadastrados',
          backgroundColor: '#008000',
          data: cadastrados
        },
        {

          label: 'Arquivados',
          backgroundColor: '#cccccc',
          data: arquivados
        }
      ]
    }})
  }

  getLightTheme() {
    let basicOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    let basicOptions2 = {
      maintainAspectRatio: false,
      aspectRatio: .8,
        plugins: {
            
        },
        scales: {
            
        }
    };

    let horizontalOptions = {
        indexAxis: 'y',
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    let stackedOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            tooltips: {
                mode: 'index',
                intersect: false
            },
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                stacked: true,
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                stacked: true,
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    let multiAxisOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057',
                }
            },
            tooltips: {
                mode: 'index',
                intersect: true
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                type: 'linear',
                display: true,
                position: 'left',
                ticks: {
                    min: 0,
                    max: 100,
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y1: {
                type: 'linear',
                display: true,
                position: 'right',
                grid: {
                    drawOnChartArea: false,
                    color: '#ebedef'
                },
                ticks: {
                    min: 0,
                    max: 100,
                    color: '#495057'
                }
            }
        }
    };

    return {
        basicOptions,
        basicOptions2,
        horizontalOptions,
        stackedOptions,
        multiAxisOptions
    }
  }

  cardProcessosParados() {
    return (
      <div style={{display: 'flex'}}>
        <label>Processo paraados&nbsp;<a onClick={this.editarConfiguracaoProcessoParado} 
                                         title="Alterar Configuração" 
                                         style={{cursor: 'pointer', color: '#58A4E4'}}>{this.state.diasProcessosParados}</a>&nbsp;dias</label>
      </div>
    )
  }

  fecharModal(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  abrirModal(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  render() {
    const { basicOptions, basicOptions2, horizontalOptions, multiAxisOptions, stackedOptions } = this.options;
    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={this.state.openSpinner}>
          <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
        </Backdrop>
        <div className="content-wrapper">
          <div className="container-fluid">
            <section className="content-header">
              <div className="card card-primary card-outline">
                <div className="card-header">
                  <h3 className="card-title">
                    <i className="pi pi-book"></i>
                    <span> Painel Gerencial Processos</span>
                  </h3>
                </div>

                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-md-2">
                          <div className="cardMiniAgendaPainel">
                            <Card title="Processos">
                                <p>
                                  <h3>{this.state.totalProcessos}</h3> 100%
                                </p>
                            </Card>
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="cardMiniAgendaPainel">
                            <Card title="Ativos">
                                <p>
                                  <h3>{this.state.totalAtivos}</h3> {this.state.totalAtivoPercentual}%
                                </p>
                            </Card>
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="cardMiniAgendaPainel">
                            <Card title={this.cardProcessosParados}>
                                <p>
                                  <h3><a title="Clique para exibir os processos"
                                         onClick={this.exibirProcessosParados} 
                                         style={{cursor: 'pointer'}}>{this.state.totalProcessosParados}</a></h3>
                                  {this.state.totalPercentualProcessosParados}%
                                </p>
                            </Card>
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="cardMiniAgendaPainel">
                            <Card title="Arquivados">
                                <p>
                                  <h3><a title="Clique para exibir os processos arquivados"
                                      onClick={this.exibirProcessosArquivados}
                                      style={{cursor: 'pointer'}}>
                                    {this.state.totalArquivados}</a></h3>{this.state.totalArquivadosPercentual}%
                                </p>
                            </Card>
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="cardMiniAgendaPainel">
                            <Card title="Lixeira">
                                <p>
                                  <h3><a title="Clique para exibir os processos na lixeira"
                                      onClick={this.exibirProcessosLixeira}
                                      style={{cursor: 'pointer'}}>
                                    {this.state.totalExcluidos}</a></h3>{this.state.totalExcluidosPercentual}%
                                </p>
                            </Card>
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="cardMiniAgendaPainel">
                            <Card title="Cadastrados este mês">
                                <p>
                                  <h3>
                                    <a title="Clique para exibir os processo cadastrados este mês"
                                       onClick={this.exibirProcessosCadastradosEsteMes}
                                       style={{cursor: 'pointer'}}>
                                    {this.state.totalProcessosCadastradosEsteMes}</a></h3>{this.state.percentualProcessosCadastradosEsteMes}%
                                </p>
                            </Card>
                          </div>
                        </div>
                      </div>
                    </div>
 
                    <div className="col-md-12">
                      <br></br>
                      <div className="row">
                        <div className="col-md-6">
                          <div class="cardMiniAgendaPainel">
                            <div class="card-header-MiniAgenda">
                              <span>Atividades</span>
                            </div>
                            <div class="card-content-MiniAgenda">
                              <div> 
                                <Chart type="bar" data={this.state.basicData2} options={basicOptions} style={{ position: 'relative', width: '100%' }} />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div class="cardMiniAgendaPainel">
                            <div class="card-header-MiniAgenda">
                              <span>Grupos de Trabalho</span>
                            </div>
                            <div class="card-content-MiniAgenda">
                              <div> 
                                <Chart type="bar" data={this.state.pieGrupoTrabalho} options={horizontalOptions} style={{ position: 'relative', width: '100%' }} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <br></br>
                      <div className="row">
                        <div className="col-md-6">
                          <div class="cardMiniAgendaPainel">
                            <div class="card-header-MiniAgenda">
                              <span>Área de Ação</span>
                            </div>
                            <div class="card-content-MiniAgenda">
                              <div> 
                                <Chart type="polarArea" data={this.state.pieAreaAtuacao} options={basicOptions2} style={{ position: 'relative', width: '100%' }} />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div class="cardMiniAgendaPainel">
                            <div class="card-header-MiniAgenda">
                              <span>Objetos de Ação</span>
                            </div>
                            <div class="card-content-MiniAgenda">
                              <div> 
                                <Chart type="doughnut" data={this.state.pieObjetosAcao} options={basicOptions2} style={{ position: 'relative', width: '100%' }} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <br></br>
                      <div className="row">
                        <div className="col-md-6">
                          <div class="cardMiniAgendaPainel">
                            <div class="card-header-MiniAgenda">
                              <span>Status Processual</span>
                            </div>
                            <div class="card-content-MiniAgenda">
                              <div> 
                                <Chart type="pie" data={this.state.pieStatusProcessual} options={basicOptions2} style={{ position: 'relative', width: '100%' }} />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div class="cardMiniAgendaPainel">
                            <div class="card-header-MiniAgenda">
                              <span>Tipo de Ação</span>
                            </div>
                            <div className="card-content-MiniAgenda">
                              <div>
                                <Chart type="pie" data={this.state.pieTipoAcao} options={basicOptions2} style={{ position: 'relative', width: '100%' }} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/**Alterar configuração de processos parados x dias*/}
              <Dialog header="Configuração Processos Parados"
                      visible={this.state.modalConfiguracaoProcessosParados} 
                      footer={this.renderFooterConfiguracaoProcessosParados('modalConfiguracaoProcessosParados')} 
                      onHide={() => this.fecharModal('modalConfiguracaoProcessosParados')}>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="diasConf">Dias</label>
                        <InputText id="diasConf" 
                                  type="text" 
                                  style={{width: '100%', height: '37px'}} 
                                  value={this.state.diasProcessosParados}
                                  onChange={e => this.setState({diasProcessosParados: e.target.value})}
                                  className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
              </Dialog>
              {/**Consultar processos parados a x dias*/}
              <Dialog header="Processos Parados"
                      visible={this.state.modalProcessosParados} 
                      footer={this.renderFooterConfiguracaoProcessosParados('modalProcessosParados')} 
                      onHide={() => this.fecharModal('modalProcessosParados')}>
                  
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <span style={{fontSize: '18px', color: '#36A2EB', fontWeight: 'bold', fontFamily: 'Times New Roman Bold Italic'}}>
                          <h5>Processos parados a mais de &nbsp;{this.state.diasProcessosParados}&nbsp; dias</h5> 
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <button type="button" className="btn btn-primary bg-gradient-primary" 
                                      data-toggle="modal" 
                                      onClick={this.filtrarProcessosParados}>
                        <i className="pi pi-search"></i> Filtrar</button>
                        &nbsp;&nbsp;<strong>{this.state.mensagemFiltro}</strong>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <DataTable value={this.state.processosParados}  alwaysShowPaginator responsiveLayout="scroll"
                                   paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                   currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10} emptyMessage=" "
                                   paginatorRight selectionMode="multiple">
                           <Column body={this.abrirProcessoLink} exportable={false} style={{ minWidth: '8rem' }} header="CNJ"/>
                           <Column field="nrProcesso" header="Número do Processo"></Column>
                           <Column field="partesDesc" header="Partes"></Column>
                           <Column field="grupoTrabalho.nome" header="Grupo de Trabalho"></Column>
                           <Column field="statusProcessual.descricao" header="Status Processual"></Column>
                           <Column field="dataCadastro" header="Data Cadastro"></Column>
                        </DataTable>
                      </div>
                    </div>
                  </div>
              </Dialog>
              {/**Filtra processos parados*/}
              <Dialog header="Filtrar Processos Parados"
                      visible={this.state.modalFiltroProcessoParado} 
                      footer={
                        <div className="right">
                            <Button label="Consultar" 
                                    onClick={this.aplicarFiltroProcessoParado}
                                    className="p-button-primary p-button-text"/>
                            &nbsp;
                            <Button label="Fechar" 
                                    className="p-button-secondary p-button-text"
                                    onClick={() => this.fecharModal('modalFiltroProcessoParado')}/>
                        </div>
                      } 
                      onHide={() => this.fecharModal('modalFiltroProcessoParado')}>
                  
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>Numeração CNJ</label>
                        <InputMask id="filtroCnj" 
                                      type="text" 
                                      mask="9999999-99.9999.9.99.9999"
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.processoParadoFiltraCnj}
                                      onChange={e => this.setState({processoParadoFiltraCnj: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label>Numeração Processo</label> 
                        <InputText id="filtroParte" 
                                   type="text" 
                                   style={{width: '100%', height: '32px'}} 
                                   value={this.state.processoParadoFiltraProcesso}
                                   onChange={e => this.setState({processoParadoFiltraProcesso: e.target.value})}
                                   className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label>Nome Parte</label> 
                        <InputText id="filtroParte" 
                                      type="text" 
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.processoParadoFiltraParte}
                                      onChange={e => this.setState({processoParadoFiltraParte: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
              </Dialog>
              {/**Consultar procesos arquivados*/}
              <Dialog header="Processos Aquivados"
                      visible={this.state.modalProcessosArquivados} 
                      footer={
                        <div className="right">
                            <Button label="Fechar" 
                                    className="p-button-secondary p-button-text"
                                    onClick={() => this.fecharModal('modalProcessosArquivados')}/>
                        </div>
                      } 
                      onHide={() => this.fecharModal('modalProcessosArquivados')}>
                  
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <span style={{fontSize: '18px', color: '#36A2EB', fontWeight: 'bold', fontFamily: 'Times New Roman Bold Italic'}}>
                          <h5>Processos Arquivados</h5> 
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <button type="button" className="btn btn-primary bg-gradient-primary" 
                                      data-toggle="modal" 
                                      onClick={this.filtrarProcessosParados}>
                        <i className="pi pi-search"></i> Filtrar</button>
                        &nbsp;&nbsp;<strong>{this.state.mensagemFiltro}</strong>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <DataTable value={this.state.processosArquivados}  alwaysShowPaginator responsiveLayout="scroll"
                                   paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                   currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10} emptyMessage=" "
                                   paginatorRight selectionMode="multiple">
                           <Column body={this.abrirProcessoLink} exportable={false} style={{ minWidth: '8rem' }} header="CNJ"/>
                           <Column field="nrProcesso" header="Número do Processo"></Column>
                           <Column field="partesDesc" header="Partes"></Column>
                           <Column field="grupoTrabalho.nome" header="Grupo de Trabalho"></Column>
                           <Column field="statusProcessual.descricao" header="Status Processual"></Column>
                           <Column field="dataCadastro" header="Data Cadastro"></Column>
                           <Column field="dataArquivamento" header="Data Arquivamento"></Column>
                        </DataTable>
                      </div>
                    </div>
                  </div>
              </Dialog>
              {/**Consultar procesos na lixeira*/}
              <Dialog header="Processos na Lixeira"
                      visible={this.state.modalProcessosLixeira} 
                      footer={
                        <div className="right">
                            <Button label="Fechar" 
                                    className="p-button-secondary p-button-text"
                                    onClick={() => this.fecharModal('modalProcessosLixeira')}/>
                        </div>
                      } 
                      onHide={() => this.fecharModal('modalProcessosLixeira')}>
                  
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <span style={{fontSize: '18px', color: '#36A2EB', fontWeight: 'bold', fontFamily: 'Times New Roman Bold Italic'}}>
                          <h5>Processos na Lixeira</h5> 
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <DataTable value={this.state.processosLixeira}  alwaysShowPaginator responsiveLayout="scroll"
                                   paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                   currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10} emptyMessage=" "
                                   paginatorRight selectionMode="multiple">
                           <Column body={this.abrirProcessoLink} exportable={false} style={{ minWidth: '8rem' }} header="CNJ"/>
                           <Column field="nrProcesso" header="Número do Processo"></Column>
                           <Column field="partesDesc" header="Partes"></Column>
                           <Column field="grupoTrabalho.nome" header="Grupo de Trabalho"></Column>
                           <Column field="statusProcessual.descricao" header="Status Processual"></Column>
                           <Column field="dataCadastro" header="Data Cadastro"></Column>
                           <Column field="dataExclusao" header="Data Exclusão"></Column>
                        </DataTable>
                      </div>
                    </div>
                  </div>
              </Dialog>
              {/**Consultar procesos cadastrados este mês*/}
              <Dialog header="Processos cadastrados este mês"
                      visible={this.state.modalProcessosEsteMes} 
                      footer={
                        <div className="right">
                            <Button label="Fechar" 
                                    className="p-button-secondary p-button-text"
                                    onClick={() => this.fecharModal('modalProcessosEsteMes')}/>
                        </div>
                      } 
                      onHide={() => this.fecharModal('modalProcessosEsteMes')}>
                  
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <span style={{fontSize: '18px', color: '#36A2EB', fontWeight: 'bold', fontFamily: 'Times New Roman Bold Italic'}}>
                          <h5>Processos cadastrados este mês</h5> 
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <DataTable value={this.state.processosCadastradosEsteMes}  alwaysShowPaginator responsiveLayout="scroll"
                                   paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                   currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10} emptyMessage=" "
                                   paginatorRight selectionMode="multiple">
                           <Column body={this.abrirProcessoLink} exportable={false} style={{ minWidth: '8rem' }} header="CNJ"/>
                           <Column field="nrProcesso" header="Número do Processo"></Column>
                           <Column field="partesDesc" header="Partes"></Column>
                           <Column field="grupoTrabalho.nome" header="Grupo de Trabalho"></Column>
                           <Column field="statusProcessual.descricao" header="Status Processual"></Column>
                           <Column field="dataCadastro" header="Data Cadastro"></Column>
                        </DataTable>
                      </div>
                    </div>
                  </div>
              </Dialog>
            </section>
          </div>
        </div>
      </>
    )
  }
}
PainelGerencialProcesso.contextType = AuthContext;
export default withRouter(PainelGerencialProcesso)
